import React, { useEffect, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebouncedCallback } from 'use-debounce';
import { Box, Flex, Text, TextField, RadioGroup } from '@radix-ui/themes';

import { AppDatePicker, Autocomplete, FormField } from 'shared/components';

import { CandidateApiService } from 'candidate/CandidateApiService';
import { Locality } from 'candidate/types';
import { observer } from 'mobx-react-lite';
import { useCreateResumeContext } from '../create-resume.context';

const PersonalInfoView = ({
   renderSteps,
}: {
   renderSteps: (valid: boolean) => ReactNode;
}) => {
   const { t } = useTranslation('global');
   const [cities, setCities] = React.useState<Locality[]>([]);

   const { personalInfo } = useCreateResumeContext();


   console.log(personalInfo.countryVM.value, 'VALUE')
   const debouncedCities = useDebouncedCallback((q: string, country_id: number) => {
      CandidateApiService.localitySearch({
         country_id: country_id,
         query: q,
      })
         .then((res) => {
            if (res.status === 200) {
               setCities(res.response);
            }
         })
         .catch((e) => {
            console.warn(e);
         });
   }, 500);

   return (
      <form>
         <Box>
            <Flex direction="column" gap="4" my="4">
               <FormField label="Імя" required error="На валідне імжя іваіва і">
                  <TextField.Root
                     size="3"
                     color="indigo"
                     name="name"
                     placeholder="П'яточкин"
                     value={personalInfo.name}
                     onChange={(e) => personalInfo.onNameChange(e.target.value)}
                  />
               </FormField>

               <FormField label="Прізвище" required>
                  <TextField.Root
                     size="3"
                     color="indigo"
                     name="lastName"
                     placeholder="П'яточкин"
                     value={personalInfo.lastName}
                     onChange={(e) => personalInfo.onLastNameChange(e.target.value)}
                  />
               </FormField>

               <FormField label="По батькові">
                  <TextField.Root
                     size="3"
                     color="indigo"
                     name="middleName"
                     placeholder="П'яточкин"
                     value={personalInfo.middleName}
                     onChange={(e) => personalInfo.onMiddleNameChange(e.target.value)}
                  />
               </FormField>

               <FormField label="Стать" required>
                  <RadioGroup.Root
                     name="gender"
                     size="3"
                     color="indigo"
                     value={personalInfo.gender}
                     onValueChange={(value) => personalInfo.onGenderChange(value)}
                  >
                     <Flex gap="2">
                        <RadioGroup.Item value="0">
                           <Text>Жіноча</Text>
                        </RadioGroup.Item>
                        <RadioGroup.Item value="1">
                           <Text>Чоловіча</Text>
                        </RadioGroup.Item>
                     </Flex>
                  </RadioGroup.Root>
               </FormField>

               <FormField label="Дата народження" required>
                  <AppDatePicker
                     inputProps={{
                        value: personalInfo.birthDate,
                        size: '3',
                        color: 'indigo',
                     }}
                     onSelect={(d) => {
                        personalInfo.onBirthDateChange(d);
                     }}
                  />
               </FormField>

               <Flex gap="3">
                  <FormField label="Країна" required>
                     <Autocomplete.Root viewModel={personalInfo.countryVM}>
                        {personalInfo.filterdCountries.map((country) => {
                           return (
                              <Autocomplete.Option value={country} key={country.id}>
                                 {country.name}
                              </Autocomplete.Option>
                           );
                        })}
                     </Autocomplete.Root>
                  </FormField>

                  <FormField label="Місто" required>
                      <Autocomplete.Root viewModel={personalInfo.cityVM} disabled={!personalInfo.countryVM.value}>
                        {personalInfo.filterdCountries.map((country) => {
                           return (
                              <Autocomplete.Option value={country} key={country.id}>
                                 {country.name}
                              </Autocomplete.Option>
                           );
                        })}
                     </Autocomplete.Root>
                  </FormField>
               </Flex>
            </Flex>
         </Box>

         <Flex>{renderSteps(personalInfo.valid)}</Flex>
      </form>
   );
};

export const PersonalInfo = observer(PersonalInfoView);
